<template>
<div>
  <app-header></app-header>
  <div class="app flex-row align-items-center">
    <div class="container">
      <b-row class="justify-content-center">
        <b-col md="8">
          <b-card-group>
            <b-card no-body class="p-4">
              <b-card-body>
                <b-form>
                  <h1>Récupération de mot de passe</h1>
                  <p class="text-muted"></p>
                   <el-alert
                    title="Si vous avez un compte avec cette adresse email, un lien de récupération de votre mot de passe vous sera envoyé"
                    type="info"
                    show-icon
                    :closable="false"
                    >
                  </el-alert><br>
                   <el-alert
                    :title="message.texte"
                    :type="message.type"
                    show-icon
                    :closable="false"
                    v-if="resetsent"
                    >
                  </el-alert><br>
                  <b-input-group class="mb-3">
                    <b-input-group-prepend><b-input-group-text><i class="icon-user"></i></b-input-group-text></b-input-group-prepend>
                    <b-form-input type="text" class="form-control" placeholder="Taper votre adresse email" autocomplete="username email"  v-model="email"/>
                  </b-input-group>
                  
                  <b-row>
                    <b-col cols="6">
                      <el-button type="primary" :loading="sendingreset" @click="onsendreset()">Envoyer</el-button>
                    </b-col>
                    <b-col cols="6" class="text-right">
                    </b-col>
                  </b-row>
                </b-form>
              </b-card-body>
            </b-card>
          </b-card-group>
        </b-col>
      </b-row>
    </div>
  </div>
  </div>
</template>

<script>
import {mapActions, mapState} from 'vuex'
import axios from 'axios'
import AppHeader from '../../containers/AppHeader';
export default {
  name: 'Login',
  components:{
    AppHeader
  },

  data: function() {
    return {
        email:'',
        sendingreset:false,
        resetsent:false,
        message:{
          texte:"",
          type:""
        }


    }
  },
  methods:{
    
    async onsendreset(){
    this.resetsent = false
    this.sendingreset = true
    axios.post(this.$store.state.baseurl+'/password/forgot',{email:this.email},{
      headers:{
        'Content-Type':'application/json'
      }
    }).then(resp=>{
      this.sendingreset = false
      this.resetsent = true
      this.message.texte = "Veuillez Consulter votre boite mail."
      this.message.type = "success"
    }).catch(err=>{
      this.sendingreset = false
      this.resetsent = true    
      this.message.texte = "Une erreur s'est produite, veuillez reéssayer."
      this.message.type = "error"
    })
  },
  
  },
  computed:{
    
  },
  mounted(){
    // console.log(this.$route.params)
  },
}
</script>

<style scoped>

</style>
